import { ScrollReveal } from '@/components/ui/scroll-reveal'
import { Card, CardContent } from '@/components/ui/card'
import { ArrowDown, Database, FileSpreadsheet, Server } from 'lucide-react'

export const TransformationSection = () => {
  return (
    <section className="py-24 bg-slate-50 overflow-hidden">
      <div className="container px-4 md:px-6">
        <ScrollReveal className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Do Excel à aplicação inteligente
          </h2>
          <p className="text-lg text-slate-600">
            Pegamos em folhas de Excel, fluxos manuais e rotinas internas e
            criamos aplicações digitais capazes de assumir registos automáticos,
            validações e muito mais.
          </p>
        </ScrollReveal>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 relative">
          <ScrollReveal delay={100} className="w-full max-w-sm z-10">
            <Card className="bg-white border-slate-200 shadow-sm hover:shadow-md transition-all">
              <CardContent className="p-8 flex flex-col items-center text-center space-y-4">
                <div className="p-4 bg-green-100 text-green-700 rounded-full">
                  <FileSpreadsheet size={40} />
                </div>
                <h3 className="text-xl font-bold text-slate-900">
                  Processos Manuais
                </h3>
                <p className="text-slate-500 text-sm">
                  Excel desorganizado, erros frequentes, dados dispersos e falta
                  de controlo.
                </p>
              </CardContent>
            </Card>
          </ScrollReveal>

          <div className="hidden md:flex flex-col items-center justify-center text-slate-300 animate-pulse z-0">
            <ArrowDown className="transform -rotate-90 w-12 h-12" />
          </div>
          <div className="md:hidden flex flex-col items-center justify-center text-slate-300 animate-pulse my-[-1rem] z-0">
            <ArrowDown className="w-12 h-12" />
          </div>

          <ScrollReveal delay={300} className="w-full max-w-sm z-10">
            <Card className="bg-white border-primary/20 shadow-lg shadow-primary/5 ring-1 ring-primary/10 hover:shadow-xl transition-all scale-105">
              <CardContent className="p-8 flex flex-col items-center text-center space-y-4">
                <div className="p-4 bg-primary/10 text-primary rounded-full">
                  <Database size={40} />
                </div>
                <h3 className="text-xl font-bold text-slate-900">
                  Aplicação Inteligente
                </h3>
                <p className="text-slate-500 text-sm">
                  Dados centralizados, automação, regras de negócio e validação
                  em tempo real.
                </p>
              </CardContent>
            </Card>
          </ScrollReveal>
        </div>
      </div>
    </section>
  )
}
